import {UPDATE_NEW_CYCLE_START} from "../../types";

export const update_new_cycle = (payload) => ({
    type: UPDATE_NEW_CYCLE_START,
    payload,
});
